import React from 'react';
import QuizTemplate from './QuizTemplate';

function QuizPitchingIdea({pb}) {
   const questions = [
      {
        questionText: 'In what way is pitching like storytelling?',
        answerOptions: [
          { answerText: 'They both follow a typical story arc', isCorrect: false },
          { answerText: 'They start with the conflict (or problem) to engage people', isCorrect: false },
          { answerText: 'All of the above', isCorrect: true },
        ],
      },
      {
        questionText: 'How do you start a pitch to grab attention?',
        answerOptions: [
          { answerText: 'Share a personal story', isCorrect: false },
          { answerText: 'Use compelling data', isCorrect: false },
          { answerText: 'Either of the above', isCorrect: true },
        ],
      },
    ]

    return(
      <div className="m-3">
         <QuizTemplate data={questions} problem={pb} />
      </div>
    )

}

export default QuizPitchingIdea;